/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ plan: NonNullable<unknown> }} Partner_Detail_Row_Plan_OneInputs */



/**
* | output |
* | --- |
* | "{plan} · 1 member" |
*
* @param {Partner_Detail_Row_Plan_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_detail_row_plan_one = /** @type {((inputs: Partner_Detail_Row_Plan_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Detail_Row_Plan_OneInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.plan} · 1 Mitglied`)
	return /** @type {LocalizedString} */ (`${i?.plan} · 1 member`)
});